import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// Import service worker unregistration script for development
import "./serviceWorkerDev";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
